import { render } from "./CampoNumerico.vue?vue&type=template&id=01bb58c6&scoped=true&ts=true"
import script from "./CampoNumerico.vue?vue&type=script&lang=ts"
export * from "./CampoNumerico.vue?vue&type=script&lang=ts"

import "./CampoNumerico.vue?vue&type=style&index=0&id=01bb58c6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bb58c6"]])

export default __exports__